import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { EnvironmentService } from '../../enviroment/environment.service';
import { LoginService } from 'lps-navigation';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class InterceptorService implements HttpInterceptor {

  constructor(
    private loginService: LoginService,
    private environmentService: EnvironmentService,
    private router: Router
  ) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(tap((resp) => {
    },
      (err: any) => {
      if (err instanceof HttpErrorResponse) {
        // if (err.status === 401) {
          // this.loginService.removeAuthInformation(this.environmentService.getEnvVar('lopes_portal_domain'));
          // this.router.navigate(['/erro/token']);
        // }
        if (err.status === 500) {
          // this.router.navigate(['/erro/servico']);
        }
      }
    }
    ));
  }
}
